export default (name, size = 20) => {
  if (!name) return name

  if (name.length > size) return name.slice(0, size-3) + '...'

  return name
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/formatters/truncate_string.js
 **/